<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="form.pkId ? '编辑' : '新建'"
        class="customer-edit"
        width="600px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          :model="form"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <el-form-item label="客户端ID" prop="clientId">
          <el-input v-model="form.clientId" :disabled="!!form.id" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="关联用户" prop="systemUserId">
          <el-input v-model="userName" disabled placeholder="请选择用户">
            <el-button slot="append" icon="el-icon-search" @click="$refs.userSelect.open()"/>
          </el-input>
        </el-form-item>
        <el-form-item label="有效期(天)" prop="expireDays">
          <el-input-number v-model="form.expireDays" :min="1" style="width: 100%"/>
        </el-form-item>
        <el-form-item label="是否启用" prop="isActive">
          <el-radio-group v-model="form.isActive">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
    <user-select ref="userSelect" @select="onSelectUser"/>
  </div>
</template>

<script>
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";

  export default {
    name: "OauthClientEdit",
    components: {UserSelect},
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        userName: "",
        form: {
          pkId: "",
          clientId: "",
          systemUserId: "",
          expireDays: "",
          isActive: 1,
          remark: "",
        },
        ruleValidate: {
          clientId: {required: true, message: "不能为空", trigger: "blur"},
          systemUserId: {required: true, message: "不能为空", trigger: "change"},
          expireDays: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        if (row) {
          console.log(row);
          this.form = {
            pkId: row.id || row.pkid,
            clientId: row.clientId,
            systemUserId: row.systemUserId,
            expireDays: row.expireDays,
            isActive: row.isActive,
            remark: row.remark,
          };
          this.userName = row.employeeName || row.userName || "";
        } else {
          this.form = {
            pkId: "",
            clientId: "",
            systemUserId: "",
            expireDays: "",
            isActive: 1,
            remark: "",
          };
          this.userName = "";
        }
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.clearValidate();
        });
      },
      onSelectUser(row) {
        this.form.systemUserId = row.systemUserID;
        this.userName = row.employeeName || row.userName;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            const data = Object.assign({}, this.form);
            if (!data.pkId) {
              delete data.pkId;
            }
            console.log(data);
            const request = data.pkId
                ? this.$http.post("basic", "oauth/client/upt", data)
                : this.$http.post("basic", "oauth/client/add", data);
            request
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
